
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-route-map-setup',
  templateUrl: './route-map-setup.component.html',
  styleUrls: ['./route-map-setup.component.scss']
})
export class RouteMapSetupComponent implements OnInit {


  public _mFormGroup: FormGroup;
  public mLocation = new FormControl('');
  public mSite = new FormControl('');
  public mMasterZone = new FormControl('');
  public mZone = new FormControl();

  _mSitesData: any[] = [];
  getVehicleData: any = [];
  _mMasterZoneData: any[] = [];
  _mZoneData: any;
  zoneData: any;
  selectedval: any = '';
  unPushedValues: any[] = [];
  pushedids: any[] = [];
  rows = [];
  cities: any[] = [];
  showFlag: boolean = false;
  masterzone: any = [];
  _mTempZoneData: any[] = [];

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private readonly localStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService,
  ) {
  }

  ngOnInit() {
    this._mFormGroup = this.fb.group({
      'location': this.mLocation,
      'site': this.mSite,
      'masterZone': this.mMasterZone,
      'mZone': this.mZone
    });
    this.loadCities();
  }

  loadCities() {
    const companyid = +this.localStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser +
      companyid,
      success => {
        this.cities = success.body;
        if (this.cities && this.cities.length > 0) {
          this.mLocation.setValue(this.cities[0].locationId);
          this.getSitesByCityId(this.cities[0].locationId);
        }
      },
      error => {
      }
    );
  }

  getSitesByCityId(cityId) {
    if (!cityId) return;
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getserchsitelist}${cityId}`,
      (success) => {
        if (success.status === 200) {
          this._mSitesData = success.body;
          if (this._mSitesData && this._mSitesData.length > 0) {
            this.mSite.setValue(this._mSitesData[0].siteId);
            this.getMasterZone({ target: { value: this._mSitesData[0].siteId } });
          }
        } else {
          this._mSitesData = [];
          this.notifyService.showInfo("No Sites Found!", null);
        }
      },
      () => { }
    );
  }

  getMasterZone(event) {
    const siteId = event.target.value;
    this._mMasterZoneData = [];
    this.apiService.doGetRequestWithResponse(ApiConstants.masterZone + siteId, success => {
      if (success.status === 200) {
        this._mMasterZoneData = success.body;
        if (this._mMasterZoneData && this._mMasterZoneData.length > 0) {
          this.mMasterZone.setValue(this._mMasterZoneData[0].id);
          // Load zones for the selected master zone without pre-filling
          this.getZones({ target: { value: this._mMasterZoneData[0].id } });
        }
      } else {
        this._mMasterZoneData = [];
        this.notifyService.showInfo("No Master Zones Found!", null);
      }
    }, (error) => {

    });
  }

  getZones(event) {
    const masterZoneId = event.target.value;
    this.apiService.doGetRequestWithResponse(ApiConstants.getZones + masterZoneId, success => {
      if (success.status === 200) {
        this._mZoneData = success.body;
        this._mTempZoneData = success.body;
      } else {
        this._mZoneData = [];
        this._mTempZoneData = [];
        this.notifyService.showInfo("No Zones Found!", null);
      }
    }, (error) => {

    });
  }

  zoneSearch(event) {
    let searchValue = event.target.value;
    if (searchValue) {
      this._mZoneData = this._mTempZoneData.filter(ele =>
        ele.name.replace(/\s+/g, '').toLowerCase().includes(searchValue.replace(/\s+/g, '').toLowerCase())
      );
    }
  }

  displayFn(zone): string {
    return zone ? zone.name : zone;
  }

  showMapping() {
    this.showFlag = false;
    this.unPushedValues = [];
    this.rows = [];
    if (!this.mZone.value?.id) {
      this.notifyService.showWarning('Please select pickup point type!', null);
      return;
    }
    this.getVehicleTypesBasedonSiteId();
  }

  getVehicleTypesBasedonSiteId() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleTypesBySiteId + "?siteId=" + this.mSite.value,
      success => {
        if (success.status == 200) {
          this.getVehicleData = success.body;
          this.getAllVehicleTypes();
        } else if (success.status == 204) {
          this.notifyService.showInfo("No Vehicles Found", null);
        }
      },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  getAllVehicleTypes() {
    this.unPushedValues = [];
    this.rows = this.getVehicleData.map(vehicleType => ({
      id: vehicleType.id,
      value: vehicleType.vehicleType
    }));
    this.getMapping();
  }

  getMapping() {
    if (!this.mSite.value) return;
    this.unPushedValues = [];
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getvehicleroutemapbysiteidandzoneid}?siteid=${this.mSite.value}&zoneid=${this.mZone.value.id}`,
      (success) => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          success.body.forEach(shiftmap => {
            this.rows = this.rows.filter(r => r.id !== shiftmap.id);
            this.unPushedValues.push({
              id: shiftmap.id,
              value: shiftmap.vehicleType,
              state: 'checked'
            });
          });
          this.showFlag = true;
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError('Error in Fetching Mapping!', null);
      }
    );
  }

  saveMapping() {
    if (!this.mZone.value?.id) {
      this.notifyService.showWarning('Please select pickup point type!', null);
      return;
    }
    if (!this.mSite.value) return;
    const pushedids = this.unPushedValues.map(item => +item.id);
    this.ngxLoader.start();
    const url = `${ApiConstants.saveRoutemapSetup}?zoneid=${this.mZone.value.id}&siteid=${this.mSite.value}&vehicleTypeId=${pushedids}`;
    this.apiService.doPostRequestWithResponse(url, '',
      (success) => {
        this.ngxLoader.stop();
        if (success.status === 201) {
          this.notifyService.showSuccess(success.body.message, null);
          this.resetForm();
        } else {
          this.notifyService.showInfo('No changes made', null);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError('Failed to Update!', null);
      }
    );
  }

  resetForm() {
    this._mFormGroup.reset();
    this.mLocation.setValue('');
    this.mSite.setValue('');
    this.mMasterZone.setValue('');
    this.mZone.setValue('');
    this.unPushedValues = [];
    this.rows = [];
    this.showFlag = false;
    this.getVehicleData = [];
  }

  isAllChecked() {
    return this.rows.every(_ => _.state);
  }

  checkAll(checks) {
    if (checks.checked) {
      this.rows.forEach(x => {
        x.state = checks.checked;
        this.onValueChecked({ checked: true }, x);
      });
    }
  }

  onValueChecked(checked, sel) {
    if (checked.checked) {
      this.rows = this.rows.filter(r => r.id !== sel.id);
      this.unPushedValues.push(sel);
    }
  }

  unCheckAll(checks) {
    if (!checks.checked) {
      this.unPushedValues.forEach(x => {
        x.state = checks.checked;
        this.onSelValuesChecked({ checked: false }, x);
      });
    }
  }

  onSelValuesChecked(checked, unselect) {
    if (!checked.checked) {
      this.rows.push(unselect);
      this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
    }
  }

  onSelValueChecked(checked, unselect) {
    if (!checked.checked) {
      this.rows.push(unselect);
      this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
    }
  }

}
